<script lang="ts">
    import DynamicEsi from '@shared/components/dynamic-esi/DynamicEsi.svelte';

    /*                                                                                                             */
    type SliderType = 'top-categories' | 'pl-category-slider';

    const endpoints: Record<SliderType, (rule: string) => string> = {
        'top-categories': (rule) => `/nav-promirnaty/top-categories/${encodeURIComponent(rule)}?encoded=true`,
        'pl-category-slider': (rule) => `/nav-promirnaty/pl-category-slider/${encodeURIComponent(rule)}?encoded=true`,
    };

    interface Props {
        rule: string;
        type: SliderType;
    }

    let { rule, type }: Props = $props();

    const src = $derived(endpoints[type](rule));
</script>

<DynamicEsi {src} name="NavCategorySlider" />
